import React from "react";
import onClickOutside from "react-onclickoutside";

const dropdownItemsCCN = [
    { id: "edit", label: "Edit" },
    { id: "remove", label: "Remove" },
]

const dropdownItemsStripe = [
    { id: "remove", label: "Remove" },
]

class CardDropdown extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdown: false
        }
    }

    handleDropdown(item,selected) {
        this.setState(prevState => {
            return { dropdown:!prevState.dropdown };
        });
        this.props.handleClick(item,selected)
    }
    handleClickOutside = evt => {
        this.setState( { dropdown:false })
      };

    cardDropdownItems() {
        if(this.props.paymentType === 'stripe') {
            return dropdownItemsStripe.map(list => (
                <li key={list.id} className="p-5 pl-20" onClick={() => this.handleDropdown(this.props.item,list.id)}>
                    {list.label}
                </li>
            ));
        }
        return dropdownItemsCCN.map(list => (
            <li key={list.id} className="p-5 pl-20" onClick={() => this.handleDropdown(this.props.item,list.id)}>
                {list.label}
            </li>
        ));
    }

    render() {
        return (
            <div>
                <div className="dropdown-btn"
                    onClick={() => { this.setState({ dropdown: !this.state.dropdown }) }}
                >
                    <span className="caret-down"></span></div>
                {this.state.dropdown ? (
                    <ul className="dropdown-menu right-0">
                        {this.cardDropdownItems()}
                    </ul>
                ) : null}
            </div>
        );
    }
}
export default onClickOutside(CardDropdown);
